import styled, {keyframes} from "styled-components";
import {Row} from "antd";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const slideOut = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
`;

export const LoginContainer = styled(Row)`
    height: 100vh;
    width: 100vw;
    display: flex;
    overflow: hidden;
`;

export const LoginWrapper = styled.div`
    display: flex;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
`;

export const BackgroundContainer = styled.div`
    flex: 0 0 auto;
    height: 100%;
    display: flex;
    flex: 0 0 720px;
    @media (max-width: 992px) {
        display: none;
    }
`;

export const LoginImage = styled.div`
    position: relative;
    height: 100vh;
    width: 100%;
    aspect-ratio: 720 / 1024;
    overflow: hidden;
`;

export const LoginImageWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: ${props => (props.isActive ? 1 : 0)};
    z-index: ${props => (props.isActive ? 1 : 0)};
    animation: ${props => (props.isActive ? slideIn : slideOut)} 1.2s ease-in-out;
    transition: opacity 1.2s ease-in-out;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const CompanyInformation = styled.div`
    .logo-header {
        position: absolute;
        top: 0;
        left: 0;
        padding: 20px;
    }
    .comment-container {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 20px;
        color: #ffffff;
        font-size: 18px;
        max-width: 720px;
        .comment {
            font-weight: bold;
        }
        .author {
            font-weight: thin;
        }
        @media (max-width: 1200px) {
            font-size: 16px;
            max-width: 500px;
        }
        @media (max-width: 992px) {
            font-size: 14px;
            max-width: 400px;
        }
    }
`;

export const CardContainer = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    padding: 0 20px;
`;

export const ButtonContainer = styled.div`
    flex-direction: column;
    max-width: 100%;
`;
